module.exports = __webpack_public_path__ + "static/media/symbol_bold__1080px__black.21bd291e.svg";